export default __webpack_public_path__ + "static/media/1-table-8-chair.dddd8dca.png";